const defaultAlertContext = {
  isOpen: false,
  id: 0
};

export default defaultAlertContext;
